import { connect } from 'react-redux'
import { sagaActions } from '../../../../sagas'
import addUserToLayoutSelector from './addUserToLayoutSelector'
import AddUserToLayout from './AddUserToLayout'

export default connect(
  addUserToLayoutSelector,
  {
    requestAddUserToLayout: sagaActions.requestAddUserToLayout,
  }
)(AddUserToLayout)
